import useLocalStorage from '@rehooks/local-storage'
import { Button, HFlow, Theme, useStyles, VFlow } from 'bold-ui'
import useSession from 'components/auth/useSession'
import { useErrorHandler } from 'components/error'
import { PageContainer } from 'components/layout/PageContainer'
import { useCancelarAtendimentoMutation, useFinalizarEscutaInicialMutation } from 'graphql/hooks.generated'
import React from 'react'
import { useHistory } from 'react-router'

import { MotivoConsultaForm, MotivoConsultaFormModel } from './motivo-consulta/MotivoConsultaForm'

interface EscutaInicialMainViewProps {
  atendimentoId: ID
}

interface EscutaInicialState {
  motivoConsulta: MotivoConsultaFormModel
}

export function EscutaInicialMainView(props: EscutaInicialMainViewProps) {
  const { atendimentoId } = props
  const { classes } = useStyles(createStyles)
  const history = useHistory()
  const [cancelar] = useCancelarAtendimentoMutation()
  const [finalizar] = useFinalizarEscutaInicialMutation()
  const { data } = useSession()
  const handleRejection = useErrorHandler()

  const [state, setState, deleteState] = useLocalStorage<EscutaInicialState>(
    `${data.acesso.id}/atendimento/escutaInicial/${atendimentoId}`
  )

  const handleMotivoConsultaChange = (motivoConsulta: MotivoConsultaFormModel) => setState({ ...state, motivoConsulta })

  const handleFinalizar = () =>
    finalizar({
      variables: {
        input: {
          id: atendimentoId,
          ciap: state?.motivoConsulta?.ciap?.id,
          motivoConsulta: state.motivoConsulta?.texto,
          finalizadoEm: new Date().getTime(),
        },
      },
    })
      .then(() => {
        deleteState()
        history.push('/lista-atendimento')
      })
      .catch(handleRejection)

  const handleCancelar = () =>
    cancelar({ variables: { atendimentoId } })
      .then(() => {
        deleteState()
        history.push('/lista-atendimento')
      })
      .catch(handleRejection)

  return (
    <div className={classes.wrapper}>
      <PageContainer>
        <div className={classes.container}>
          <aside className={classes.aside}>
            <pre>
              <code>{JSON.stringify(state, null, 2)}</code>
            </pre>
          </aside>
          <div className={classes.content}>
            <VFlow>
              <MotivoConsultaForm initialValues={state?.motivoConsulta} onSubmit={handleMotivoConsultaChange} />
            </VFlow>
          </div>
        </div>
      </PageContainer>

      <div className={classes.actions}>
        <PageContainer>
          <HFlow justifyContent='flex-end'>
            <Button kind='danger' onClick={handleCancelar}>
              Cancelar escuta inicial
            </Button>
            <Button kind='primary' onClick={handleFinalizar}>
              Finalizar escuta inicial
            </Button>
          </HFlow>
        </PageContainer>
      </div>
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  wrapper: {
    paddingBottom: '4rem',
  },
  container: {
    display: 'grid',
    gridTemplateColumns: 'calc(256px + 1rem) 1fr',
    gridGap: '1rem',
  },
  aside: {
    padding: '1rem 1rem 1rem 0',
    borderRight: `1px solid ${theme.pallete.divider}`,
  },
  content: {
    padding: '1rem 0',
  },
  actions: {
    borderTop: `1px solid ${theme.pallete.divider}`,
    paddingTop: '1rem',
  },
})
